module.exports = __webpack_public_path__ + "static/media/_DSC1875.8c0266eb.jpg";